import React, { forwardRef, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CalendarIcon, IconButton } from "@activecollab/components";
import moment from "moment";
import PropTypes from "prop-types";
import SelectDateNonWorkingDays from "~/components/SelectDate/SelectDateNonWorkingDays";

const SelectDateTrigger = forwardRef(({ onClick, open }, ref) => {
  const { t } = useTranslation();

  return (
    <IconButton
      active={open}
      variant="text gray"
      className="c-cooltip c-cooltip--top tw-overflow-visible"
      data-tooltip={t("Change Date")}
      onClick={onClick}
      ref={ref}
    >
      <CalendarIcon />
    </IconButton>
  );
});

SelectDateTrigger.displayName = "SelectDateTrigger";
SelectDateTrigger.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
};

const trigger = () => {
  return <SelectDateTrigger />;
};

export const SelectTrackingRecordDate = ({ selectedDate, startDate, onChange, canTrackForOther, backtrackMaxDays }) => {
  const disableDaysBefore = canTrackForOther ? null : moment.unix(startDate).subtract(backtrackMaxDays, "days");

  const handleChange = useCallback(
    ({ from }) => {
      if (onChange) {
        onChange({ record_date: from });
      }
    },
    [onChange]
  );

  const selectedDays = useMemo(
    () => ({
      from: selectedDate,
      to: selectedDate,
    }),
    [selectedDate]
  );

  return (
    <SelectDateNonWorkingDays
      changeMode="atomic"
      trigger={trigger}
      selectedDays={selectedDays}
      onSave={handleChange}
      selectionMode="daily"
      required
      type="selectable_global_day_off"
      weekendIsSelectable
      disableDaysBefore={disableDaysBefore}
    />
  );
};

SelectTrackingRecordDate.propTypes = {
  backtrackMaxDays: PropTypes.number,
  canTrackForOther: PropTypes.bool,
  onChange: PropTypes.func,
  selectedDate: PropTypes.number,
  startDate: PropTypes.number,
};
